import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { DeviceService } from '../service/device.service';

@Injectable({
  providedIn: 'root'
})
export class DesktopGuard implements CanActivate {
  constructor(
    private deviceService: DeviceService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.deviceService.isMobile()) {
      this.router.navigate(['/mobile-warning']);
      return false;
    }
    return true;
  }
} 